import React, { useState } from "react";
import {
  Route,
  Routes,
  BrowserRouter as Router,
  useNavigate,
  useLocation,
} from "react-router-dom";
import "./App.css";
import Login from "./Pages/Login";
import Signup from "./Pages/Signup";
import ForgotPassword from "./Pages/ForgotPassword";
import ResetPassword from "./Pages/ResetPassword";
import Dashboard from "./Pages/Dashboard";
import DashboardHome from "./Pages/DashboardHome";
import Settings from "./Pages/Settings";
import Account from "./Pages/Account";
import Staff from "./Pages/Staff";
import Permissions from "./Pages/Permissions";
import Create from "./Pages/Create";
import ChangePassword from "./Pages/ChangePassword";
import Product from "./Pages/Product";
import Customers from "./Pages/Customers";
import Price from "./Pages/Price";
import Requisition from "./Pages/Requisition";
import Approval from "./Pages/Approval";
import AcceptApprove from "./Pages/AcceptApprove";
import LoadingSlip from "./Pages/LoadingSlip";
import Slip from "./Pages/Slip";
import GeneratedSlip from "./Pages/GeneratedSlip";
import Invoice from "./Pages/Invoice";
import InvoiceTable from "./Pages/InvoiceTable";
import Bank from "./Pages/Bank";
import ActivityLogs from "./Pages/ActivityLogs";
import UserProfile from "./Pages/UserProfile";
import AdminStaff from "./Pages/AdminStaff";
import SuperStaff from "./Pages/SuperStaff";
import StaffTable from "./Pages/StaffTable";
import Quantity from "./Pages/Quantity";
import Report from "./Pages/Report";
import LoadingSlipTable from "./Pages/LoadingSlipTable";
import RequisitionTable from "./Pages/RequisitionTable";
import Transport from "./Pages/Transport";
import Transactions from "./Pages/Transactions";
import LoadingReportTable from "./Pages/Report/LoadingReport";
import RequisitionReport from "./Pages/Report/RequisitionReport";
import BankReport from "./Pages/Report/BankReport";
import NotInvoicedTable from "./Pages/NotInvoiced";
import StaffLogin from "./Pages/StaffLogin";
import BankTable from "./Pages/BankTable";
import ApproveReport from "./Pages/Report/ApprovalReport";
import InvoiceReport from "./Pages/Report/InvoiceReport";
import Refund from "./Pages/Refund";
import RequiRefund from "./Pages/RequiRefund";
import NewPass from "./Pages/NewPass";
import TruckInOut from "./Pages/Report/TruckInOut";
import RefundReport from "./Pages/Report/RefundReport";
import ContinueGeneratingSlip from "./Pages/ContinueGeneratingSlip";
import GeneratedSlipNotInvoiced from "./Pages/GeneratedSlipNotInvoiced";
import MergedLoadingSlip from "./Pages/MergedLoadingSlip";
import MergedGeneratedSlipNotInvoiced from "./Pages/MergedNotInvoicedSlips";
import LicensingMenu from "./Pages/LicensingMenu";
import RegisterLicense from "./Pages/RegisterLicense";
import AllocationReport from "./Pages/Report/DailyAllocationReport";
import CreateAllocation from "./Pages/CreateAllocation";
import LicenseTable from "./Pages/LicenseTable";
import TruckTable from "./Pages/TruckTable";
import VerifyEmail from "./Pages/VerifyEmail";

function App() {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/stafflogin" element={<StaffLogin />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/newpassword" element={<NewPass />} />
        <Route path="dashboard" element={<Dashboard />}>
          <Route index element={<DashboardHome />} />
          <Route path="settings" element={<Settings />}>
            <Route index element={<Account />} />
            <Route path="staff" element={<Staff />} />
            <Route path="permissions" element={<Permissions />} />
            <Route path="createrole" element={<Create />} />
            <Route path="changePassword" element={<ChangePassword />} />
          </Route>
          <Route path="bank" element={<Bank />} />
          <Route path="banktable" element={<BankTable />} />
          <Route path="truckTable" element={<TruckTable />} />
          <Route path="transport" element={<Transport />} />
          <Route path="product" element={<Product />} />
          <Route path="customer" element={<Customers />} />
          <Route path="price" element={<Price />} />
          <Route path="quantity" element={<Quantity />} />
          <Route path="requisition" element={<Requisition />} />
          <Route path="requisitontable" element={<RequisitionTable />} />
          <Route path="approval" element={<Approval />} />
          <Route path="accept" element={<AcceptApprove />} />
          <Route path="loadingslip" element={<LoadingSlip />} />
          <Route path="mergedloadingslip" element={<MergedLoadingSlip />} />
          <Route path="merged-generated-slips" element={<MergedGeneratedSlipNotInvoiced />} />
          <Route path="loadingtable"
            element={<LoadingSlipTable />} />
          <Route path="notinvoiced" element={<NotInvoicedTable />} />
          <Route path="slip" element={<Slip />} />
          <Route path="generatedslip" element={<GeneratedSlip />} />
          <Route path="generatedslipNi" element={<GeneratedSlipNotInvoiced />} />
          <Route path="continue-generating-slip" element={<ContinueGeneratingSlip />} />
          <Route path="invoice" element={<Invoice />} />
          <Route path="invoicetable" element={<InvoiceTable />} />
          <Route path="licensing-menu" element={<LicensingMenu />} />
          <Route path="register-license" element={<RegisterLicense />} />
          <Route path="create-allocation" element={<CreateAllocation />} />
          <Route path="licenses" element={<LicenseTable />} />

          <Route path="activitylogs" element={<ActivityLogs />} />
          <Route path="userstaff" element={<UserProfile />} />
          <Route path="adminstaff" element={<AdminStaff />} />
          <Route path="superstaff" element={<SuperStaff />} />
          <Route path="stafftable" element={<StaffTable />} />
          <Route path="transaction" element={<Transactions />} />
          <Route path="requirefund" element={<RequiRefundWrapper />} />
          <Route path="refund" element={<RefundWrapper />} />
          <Route path="report" element={<Report />}>
            <Route index element={<RequisitionReport />} />
            <Route path="loadingreport" element={<LoadingReportTable />} />
            <Route path="bankreport" element={<BankReport />} />
            <Route path="refundreport" element={<RefundReport />} />
            <Route path="truckinout" element={<TruckInOut />} />
            <Route path="approvalreport" element={<ApproveReport />} />
            <Route path="invoiceReport" element={<InvoiceReport />} />
            <Route path="allocationreport" element={<AllocationReport />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

const RefundWrapper = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const customerAccount = location.state;

  const handleRefund = () => {
    navigate("/dashboard/customer"); // Navigate to the customer page
  };

  const [isRefund, setIsRefund] = useState(false);

  return (
    <Refund
      setRefund={setIsRefund}
      customer={customerAccount}
      handleRefund={handleRefund}
    />
  );
};

const RequiRefundWrapper = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const handleRequiRefund = () => {
    navigate("/dashboard/accept");
  };
  const { requisitionId, items } = location.state;

  const [isRequiRefund, setIsRequiRefund] = useState(false);

  return (
    <RequiRefund
      handleRequiRefund={handleRequiRefund}
      setRequiRefund={setIsRequiRefund}
      requisitionNum={{ requisitions: [] }}
      requisitionId={requisitionId}
      items={items}
    />
  );
};

export default App;
